const EntityHome = () => import(/* webpackChunkName: "entityHome" */ '@/components/EntityHome')
const routes = [
    {
        path: '/researchPeriods',
        component: EntityHome,
        meta: { breadCrumb: 'Research Periods', entity: 'editResearchPeriod' },
        children: [
            {
                name: 'researchPeriods',
                path: '/',
                component: () => import('@/pages/researchPeriod/List.vue'),
            },
            {
                name: 'editResearchPeriod',
                path: 'edit/:id',
                props: true,
                component: () => import('@/pages/researchPeriod/Editor.vue'),
            },
            {
                name: 'newResearchPeriod',
                path: 'new',
                props: true,
                component: () => import('@/pages/researchPeriod/Editor.vue'),
            },
        ],
    },
]

export default routes
